/** @file ToastLayer: the shell's toasts (5 s each) and the sticky stale-build toast. */
import { useEffect } from 'react';
import type { ReactElement } from 'react';
import type { Toast } from '../state/editorTypes';
import { useEditor } from '../state/useEditor';
import { StaleBuildToast } from './StaleBuildToast';

/** How long a toast stays, in milliseconds. */
const TOAST_MS = 5000;

function ToastItem({ toast, dismiss }: { toast: Toast; dismiss: (id: number) => void }): ReactElement {
  useEffect(() => {
    const handle = setTimeout(() => { dismiss(toast.id); }, TOAST_MS);
    return () => { clearTimeout(handle); };
  }, [toast.id, dismiss]);
  return (
    <div className={`p3-toast p3-toast-${toast.kind}`} role={toast.kind === 'error' ? 'alert' : 'status'}>
      <span>{toast.text}</span>
      <button type="button" className="p3-btn p3-btn-ghost p3-icon-btn" aria-label="Dismiss" onClick={() => { dismiss(toast.id); }}>×</button>
    </div>
  );
}

/** Bottom-right stack of `state.toasts`, newest last; `stale` adds the sticky "newer Pose3D is live" toast at the bottom. */
export function ToastLayer({ stale = false }: { stale?: boolean }): ReactElement {
  const toasts = useEditor((s) => s.toasts);
  const dismiss = useEditor((s) => s.dismissToast);
  return (
    <div className="p3-toasts">
      {toasts.map((t) => <ToastItem key={t.id} toast={t} dismiss={dismiss} />)}
      {stale ? <StaleBuildToast /> : null}
    </div>
  );
}
